import SocketService from './SocketService.js'
import Platform from './Platform.js'
import Module from './Module.js'
import BrowserView from './BrowserView.js'

window.danmaku = {
  platform: Platform,
  module: Module,
  browserView: BrowserView,
  socketService: SocketService
}



// WEBPACK FOOTER //
// ./src/container/index.js